import api from '@pray/shared/utils/api';
type Row = { item_id: string; data: Record<string, string | number | boolean> };
type Props = { artistId: string; catalogId: string; rows: Row[] };
export async function patchItem({ artistId, catalogId, rows }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Unwrap the backend envelope ({ responded_at, object, data }) one level — see getCatalogs.ts.
  const res = await api.executePatchRequest<{ data: unknown }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/items`, { rows });
  return res.data.data;
}
